import { lazyLoad } from 'utils/loadable';

export const UserListPage = lazyLoad(
  () => import('./index'),
  module => module.UserListPage,
);
